import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { FooterReport, Gap, GridInline, LabelTitle, Line } from "../../../../components/Global";
import "react-loading-skeleton/dist/skeleton.css";
import { CONFIG_DEV } from "../../../../config/ConfigDev";
import accountManagement from "../../../../apis/accountManagement";
import LoaderModal from "../../../../components/modal/LoaderModal";
import PageTwo from "./PageTwo";
import LoadingPage from "./LoadingPage";

const PageOne = ({
    idJadwalCbt,
    idKelas,
    kodeTahunAjaran,
    kuotaMatematika,
    kuotaFisika,
    kuotaBiologi,
    kuotaKimia,
    kuotaInformatika,
    kuotaGeografi,
    kuotaSosiologi,
    kuotaEkonomi,
    kuotaAntropologi,
    kuotaBahasaInggris,
    kuotaBahasaIndonesia,
    kuotaBahasaAsing,
    kuotaVokasiDanPrakarya,
}) => {
    const [fetching, setFetching] = useState(false);
    const [detailSekolah, SetDetailSekolah] = useState([]);
    const [listFinalJurusan, SetListFinalJurusan] = useState([]);
    const [openPage, setOpenPage] = useState(false);

    const today = new Date();
    const suflix = today.getHours() >= 12 ? " PM" : " AM";
    const dateTime = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear() + ", " + today.getHours() + "." + today.getMinutes() + suflix;

    useEffect(() => {
        const getDatas = async () => {
            setFetching(true);
            const response = await accountManagement
                .post(CONFIG_DEV.REPORT_PEMETAAN_PAGE_ONE, {
                    idJadwalCbt: idJadwalCbt,
                    idKelas: idKelas,
                    kodeTahunAjaran: kodeTahunAjaran,
                    kuotaMatematika: kuotaMatematika,
                    kuotaFisika: kuotaFisika,
                    kuotaBiologi: kuotaBiologi,
                    kuotaKimia: kuotaKimia,
                    kuotaInformatika: kuotaInformatika,
                    kuotaGeografi: kuotaGeografi,
                    kuotaSosiologi: kuotaSosiologi,
                    kuotaEkonomi: kuotaEkonomi,
                    kuotaAntropologi: kuotaAntropologi,
                    kuotaBahasaInggris: kuotaBahasaInggris,
                    kuotaBahasaIndonesia: kuotaBahasaIndonesia,
                    kuotaBahasaAsing: kuotaBahasaAsing,
                    kuotaVokasiDanPrakarya: kuotaVokasiDanPrakarya,
                })
                .catch(function (error) {
                    console.error("Error HW_REPORT_BY_KP", error);
                });

            if (response) {
                if (response.data.data) {
                    const responseAPI = response.data.data;
                    console.log("====================================");
                    console.log("Response Page One ", responseAPI);
                    console.log("====================================");

                    SetDetailSekolah(responseAPI.detailSekolah);
                    SetListFinalJurusan(responseAPI.listFinalJurusanRekomendasiPlacement);
                }
                setFetching(false);
                setOpenPage(true);
            }
        };
        getDatas();
    }, []);

    require("../Pemetaan.css");
    return (
        <>
            <LoaderModal isFetching={fetching} />
            <div className="report-page">
                <div className="header-first-page">
                    <div className="text-header">
                        <div className="title-header">SCHOOL ASSESSMENT REPORT</div>
                        <div className="sub-title-header">Asesmen Diagnostik</div>
                    </div>
                    <div className="img-header">
                        <img src="/assets/image/pemetaan.png" width={"20%"} />
                    </div>
                </div>
                <Gap height={20} />
                <div style={{ width: "95%", paddingLeft: "5%" }}>
                    <Line color={"#1D3557"} />
                </div>
                <Gap height={20} />
                <div className="section-one">
                    <div className="biodata-school">
                        {/* Nama Sekolah */}
                        <GridInline width={"50%"} borderRight={"1px solid #E9ECEF"}>
                            <GridInline width={"7%"} marginRight={5}>
                                <img src="/assets/image/school.png" width={"100%"} style={{ marginBottom: -15 }} />
                            </GridInline>
                            <GridInline width={"75%"}>
                                <LabelTitle label={"Nama Sekolah"} size={15} bolder={500} color={"#495057"} />
                            </GridInline>
                            <div style={{ marginLeft: 35 }}>
                                <LabelTitle label={detailSekolah.namaSekolah} size={14} bolder={300} color={"#6C757D"} />
                                {/* <Skeleton /> */}
                            </div>
                        </GridInline>
                        {/* Jumlah Peserta */}
                        <GridInline width={"25%"} paddingLeft={20}>
                            <GridInline width={"14%"} marginRight={5}>
                                <img src="/assets/image/jumlah-peserta.png" width={"100%"} style={{ marginBottom: -15 }} />
                            </GridInline>
                            <GridInline>
                                <LabelTitle label={"Jumlah Siswa"} size={15} bolder={500} color={"#495057"} />
                            </GridInline>
                            <div style={{ marginLeft: 35 }}>
                                <LabelTitle label={detailSekolah.totalSiswa + " Siswa"} size={14} bolder={300} color={"#6C757D"} />
                            </div>
                        </GridInline>
                        {/* Tanggal Pelaksanaan */}
                        <GridInline width={"25%"}>
                            <GridInline width={"14%"} marginRight={5}>
                                <img src="/assets/image/tgl.png" width={"100%"} style={{ marginBottom: -15 }} />
                            </GridInline>
                            <GridInline>
                                <LabelTitle label={"Tanggal Pelaksanaan"} size={15} bolder={500} color={"#495057"} />
                            </GridInline>
                            <div style={{ marginLeft: 35 }}>
                                <LabelTitle label={detailSekolah.tanggalPelaksanaan} size={14} bolder={300} color={"#6C757D"} />
                            </div>
                        </GridInline>
                    </div>
                    <Gap height={20} />
                    <div style={{ width: "95%", paddingLeft: "5%" }}>
                        <Line color={"#E9ECEF"} />
                    </div>
                    <Gap height={20} />
                    <div className="result">
                        <div className="result-pageone">
                            <LabelTitle label={"Summary Asesmen Diagnostik Kognitif"} size={18} bolder={700} color={"#fff"} />
                        </div>
                        <Gap height={20} />
                        <div className="head-table-result">
                            <GridInline width={"100%"} padding={15} marginLeft={15}>
                                <GridInline width={"48%"} marginLeft={15} paddingTop={10}>
                                    <LabelTitle label={"Mata Pelajaran"} size={20} bolder={800} color={"#000"} />
                                </GridInline>
                                <GridInline width={"25%"} textAlign={"center"}>
                                    <LabelTitle label={"Recomendation"} size={20} bolder={800} color={"#000"} />
                                </GridInline>
                                <GridInline width={"25%"} textAlign={"center"}>
                                    <LabelTitle label={"Placement"} size={20} bolder={800} color={"#000"} />
                                </GridInline>
                            </GridInline>
                        </div>
                        <div className="table-result">
                            {listFinalJurusan.map((hasilPemetaan, i) => {
                                return (
                                    <div key={i}>
                                        <GridInline width={"100%"} padding={15} marginLeft={15}>
                                            <GridInline width={"48%"} marginLeft={15} paddingTop={10}>
                                                {hasilPemetaan.namaJurusan}
                                            </GridInline>
                                            <GridInline width={"25%"} textAlign={"center"}>
                                                {hasilPemetaan.totalRekomendasi} Siswa
                                            </GridInline>
                                            <GridInline width={"25%"} textAlign={"center"}>
                                                {hasilPemetaan.totalPlacement} Siswa
                                            </GridInline>
                                        </GridInline>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <Gap height={40} />
                {/* <div className="reportFooter">
                    <FooterReport color={"#1D3557"} date={dateTime} />
                </div> */}
            </div>

            {openPage ? <PageTwo idJadwalCbt={idJadwalCbt} idKelas={idKelas} kodeTahunAjaran={kodeTahunAjaran} schoolName={detailSekolah.namaSekolah} /> : <LoadingPage />}
        </>
    );
};

export default PageOne;
